/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import "../../../assets/styles/custom-style.scss";
import {
  BannerDetails,
  ProfileDetails,
  listCertificate,
  listTiming,
} from "../core/_requests";
import PlanUnsubscribe from "./listCompomponents/PlanUnsubscribe";
import DeleteAccount from "./listCompomponents/DeleteAccount";
import ChangePassword from "./listCompomponents/ChangePassword";
import TimeSettings from "./listCompomponents/TimeSettings";
import ProfileLevelSettings from "./listCompomponents/ProfileLevelSettings";
import CertificateSettings from "./listCompomponents/CertificateSettings";
import PlanRenewalSettings from "./listCompomponents/PlanRenewal";
import BrandSettings from "./listCompomponents/BrandSettings";
import NotificationSettings from "./listCompomponents/NotificationSettings";
import BioSettings from "./listCompomponents/BioSettings";
import ProfileSettings from "./listCompomponents/ProfileSettings";
import CoverImageSettings from "./listCompomponents/CoverImageSettings";
import { saveDeviceToken } from "../../../auth/core/_requests";
const ListSettings = () => {
  const { currentUser } = useAuth();
  const [listProfile, setListProfile] = useState<any>();
  const [banners, setBanners] = useState<string[]>([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [timing, setTiming] = useState<any>();
  const [certificateList, setCertificate] = useState<any>();
  const chefId = currentUser?.uuid || "";

  useEffect(() => {
    ProfileDetails(chefId).then((res) => {
      setListProfile(res?.data);
    });

    listTiming(chefId)
      .then((res) => {
        setTiming(res);
      })
      .catch((error) => {
        console.error("Error fetching timing data:", error);
      });

    listCertificate(chefId)
      .then((res) => {
        setCertificate(res?.data);
      })
      .catch((error) => {
        console.error("Error fetching timing data:", error);
      });

    BannerDetails(chefId)
      .then((res) => {
        if (Array.isArray(res?.data)) {
          setBanners(res?.data);
        } else {
          console.error("Expected banner data to be an array", res?.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching banner details:", error);
      });
  }, [chefId]);

  // Auto-rotate banners every 2 seconds
  useEffect(() => {
    if (banners.length <= 1) return; // No need for rotation if 1 or fewer banners
    
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => 
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // 2 seconds
    
    return () => clearInterval(interval);
  }, [banners.length]);
  useEffect(() => {
  if (!currentUser?.uuid) return;

  saveFcmTokenToServer({
    userId: currentUser.uuid,
    userType: "chef",
    appVersion: "v1",
  });

}, [currentUser]);
const getDeviceType = (): string => {
  const ua = navigator.userAgent.toLowerCase();

  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  if (ua.includes("edg")) return "edge";
  if (ua.includes("chrome") && !ua.includes("edg") && !ua.includes("opr"))
    return "chrome";
  if (ua.includes("firefox")) return "firefox";
  if (ua.includes("safari") && !ua.includes("chrome")) return "safari";

  return "web";
};

// 📌 Save token to server only if notifications enabled
const saveFcmTokenToServer = async ({
  userId,
  userType,
  appVersion,
}: {
  userId: string;
  userType: string;
  appVersion: string;
}) => {
  try {
    //  Detect + inform parent to show message
  

    let deviceToken = localStorage.getItem("fcmToken");

  
    if (!deviceToken) {
      console.warn("❌ No FCM token. Save skipped.");
      return;
    }

    const deviceType = getDeviceType();

    await saveDeviceToken({
      userId,
      userType,
      deviceToken,
      deviceType,
      appVersion,
    });

    console.log("📌 Device token saved successfully!");
  } catch (error) {
    console.error("❌ Error saving device token:", error);
  }
};
  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            {/* <!-- Main Content Section Starts here --> */}
            <section className="row main-content settlement-content settings-content">
              <div className="title mb-3 d-flex align-items-center">
                <h3 className="mb-0 me-2">My Account</h3>
                <p className="mb-0 opacity-150 mt-2">
                  <i
                    className="material-symbols-outlined info-ico me-1"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={`Hello ${
                      currentUser?.data?.name || "there"
                    }! Update your restaurant's banner and profile to shine on the user app!`}
                  >
                    info
                  </i>
                </p>
              </div>

              {/* <!-- Content Wrap Starts here --> */}
              <div className="col-12">
                <div className="row mb-4">
                  <div className="col-md-8">
                    <div className="snippet-block p-0">
                      <CoverImageSettings bannerImage={banners[currentBannerIndex] || ""} banners={banners} />
                      <div className="cover-cont">
                        <ProfileSettings  listProfile={listProfile}/>
                        <BioSettings listProfile={listProfile} />
                        <NotificationSettings listProfile={listProfile} />
                        <BrandSettings listProfile={listProfile} />
                        <PlanRenewalSettings   listProfile={listProfile}  currentUser={currentUser}/>
                        <CertificateSettings  certificateList={certificateList} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <ProfileLevelSettings timing={timing} />
                      <TimeSettings timing={timing} listProfile={listProfile} />
                      <ChangePassword />
                      <PlanUnsubscribe />
                      <DeleteAccount />
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Content Wrap Ends here --> */}
            </section>
            {/* <!-- Main Content Section Ends here --> */}
          </section>
        </div>
      </section>
    </>
  );
};

export default ListSettings;